var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1895 6.6C25.8831 3.66667 30.117 3.66667 31.8105 6.6L48.4382 35.4C50.1318 38.3333 48.0148 42 44.6277 42H11.3723C7.98519 42 5.86824 38.3333 7.5618 35.4L24.1895 6.6Z",
    fill: "#F09E24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5462 18.383C25.5351 16.7962 27.1884 15.6516 28.7038 16.1097C29.9042 16.4724 30.563 17.5065 30.4307 18.7418C30.1591 21.28 29.9113 23.8205 29.6532 26.3603C29.5487 27.3864 29.4521 28.4141 29.3357 29.4386C29.2597 30.1036 28.6587 30.6158 27.996 30.6134C27.3309 30.6111 26.7347 30.1012 26.6634 29.4307C26.4433 27.3522 26.2406 25.2722 26.0292 23.193C25.8795 21.719 25.7267 20.2459 25.5763 18.772C25.5597 18.6145 25.5517 18.4562 25.5462 18.383Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0239 31.8028C29.1562 31.8107 30.0556 32.7159 30.0517 33.843C30.0477 34.9598 29.1261 35.873 28.0033 35.8722C26.8648 35.8722 25.9392 34.9368 25.9558 33.8025C25.9724 32.6785 26.8861 31.7948 28.0239 31.8028Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c88fbcbd5a8c9913d9e21013913b1d57.svg";
export { ForwardRef as ReactComponent };